// pf/settlement.ts — how this session's rounds are paid, for the rounding fine print (SC-65243). The fine print states the
// rule the RGS applies, never another: the fairness v1 settlement (each payout settled at the cent by a verifiable random
// draw that keeps the exact expected value) once the accepted terms of the pf ticket held for the next roll say
// "stochastic"; floor-toward-house before (legacy rounds, a ticket whose terms say "floor", the demo). Only a definite
// answer changes it: "unavailable" is also the moment between a spent ticket and its successor, and a ticket stated with no
// terms says nothing about the rounding.
import type { PfTicketPayload } from "@blocklabsdev/rgs-game-manager-frontend-api";

export type SettlementShown = "stochastic" | "floor";

export function settlementShown(state: PfTicketPayload | null, previous: SettlementShown): SettlementShown {
  if (state?.mode === "legacy") return "floor";
  if (state?.mode !== "tickets") return previous;
  const policy = state.ticket.acceptedTerms?.settlementPolicy;
  return policy === "stochastic" ? "stochastic" : policy === undefined ? previous : "floor";
}
